import { PERSONAL_DETAILS_EVENT } from "src/events/constant";
import useCleverTapEvents from "src/events/useGetEvents";

export type IKey = 'gender' |
'maritalStatus' |
'occupation' |
'incomeSegment' |
'tradingExperience' |
'fatherName' |
'segmentSelection';

const usePersonalDetailsEvents = () => {
  const { TriggerEvent } = useCleverTapEvents();

  const TriggerPersonalDetailsEvent = (key: IKey, value: string) => {
    if (typeof value === 'string') {
      if (key === "gender") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.gender, { gender: value })
      } else if (key === "maritalStatus") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.maritalStatus, { maritalStatus: value })
      } else if (key === "occupation") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.occupation, { occupation: value })
      } else if (key === "incomeSegment") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.income, { annualIncome: value })
      } else if (key === "tradingExperience") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.tradingExperience, { tradingExperience: value })
      } else if (key === "segmentSelection") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.segmentSubmit, { fno: Boolean(value) })
      } else if (key === "fatherName") {
        TriggerEvent(PERSONAL_DETAILS_EVENT.segmentSubmit, { })
      }
    }
  }

  return { TriggerPersonalDetailsEvent };
}

export default usePersonalDetailsEvents;
